module.exports = __webpack_public_path__ + "img/Boss-5.212e096f.png";